var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.996 8.006l6.752-6.621-1.416-1.389-5.336 5.232L1.666.003.252 1.39z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--chevron-down-baf9ab8f6d6ea545ec907fab81189523.svg";
export { SvgIconUiChevronDown as Component };